import { render, staticRenderFns } from "./MyPointsMetadataModel.vue?vue&type=template&id=5f2c5a73&"
import script from "./MyPointsMetadataModel.js?vue&type=script&lang=js&"
export * from "./MyPointsMetadataModel.js?vue&type=script&lang=js&"
import style0 from "./MyPointsMetadataModel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VIcon,VSelect})
